var modules_7f679c10 = {"label":"_4kdam9"};
import "../../../assets/CqJrmx0d.css";

export { modules_7f679c10 as default };
//# sourceMappingURL=DoneContent.module.less.js.map
